import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mb-5"},[_c(VCardText,[(_vm.filters.length <= 0)?[_c(VCardText,[_c('div',{staticClass:"text-center"},[_vm._v("Filter belum di tambahkan")])])]:_vm._e(),_vm._l((_vm.filters),function(data,i){return [(!data.filters)?[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{attrs:{"lg":"2"}},[_c(VAutocomplete,{attrs:{"label":i == 0 ? 'Where' : 'Tipe',"disabled":i == 0,"items":[
                {
                  value: 'and',
                  text: 'And',
                },
                {
                  value: 'or',
                  text: 'Or',
                },
              ]},model:{value:(data.type),callback:function ($$v) {_vm.$set(data, "type", $$v)},expression:"data.type"}})],1),_c(VCol,{attrs:{"lg":"3"}},[_c(VAutocomplete,{attrs:{"label":"Kolom","items":[
                {
                  value: 'guru_id',
                  text: 'Guru',
                },
                {
                  value: 'ruang',
                  text: 'Ruang',
                },
                {
                  value: 'mata_pelajaran_id',
                  text: 'Mata Pelajaran',
                },
                {
                  value: 'rombel_id',
                  text: 'Rombel',
                },
                {
                  value: 'hari',
                  text: 'Hari',
                },
                {
                  value: 'jam_kbm.ke',
                  text: 'Jam KBM',
                },
              ]},model:{value:(data.column),callback:function ($$v) {_vm.$set(data, "column", $$v)},expression:"data.column"}})],1),_c(VCol,{attrs:{"lg":"2"}},[(
                data.column == 'guru_id' ||
                data.column == 'mata_pelajaran_id' ||
                data.column == 'rombel_id' ||
                data.column == 'hari'
              )?_c(VAutocomplete,{attrs:{"label":"Operasi","items":[
                {
                  value: '=',
                  text: '=',
                },
                {
                  value: '!=',
                  text: '!=',
                },
              ]},model:{value:(data.operator),callback:function ($$v) {_vm.$set(data, "operator", $$v)},expression:"data.operator"}}):(data.column == 'jam_kbm.ke')?_c(VAutocomplete,{attrs:{"label":"Operasi","items":[
                {
                  value: '=',
                  text: '=',
                },
                {
                  value: '<',
                  text: '<',
                },
                {
                  value: '>',
                  text: '>',
                },
                {
                  value: '<=',
                  text: '<=',
                },
                {
                  value: '>=',
                  text: '>=',
                },
                {
                  value: 'between',
                  text: 'Antara',
                },
              ]},model:{value:(data.operator),callback:function ($$v) {_vm.$set(data, "operator", $$v)},expression:"data.operator"}}):_c(VAutocomplete,{attrs:{"label":"Operasi","items":[
                {
                  value: 'like',
                  text: 'Mengandung',
                },
                {
                  value: 'not_like',
                  text: 'Tidak mengandung',
                },
                {
                  value: 'start_with',
                  text: 'Diawali Dengan',
                },
                {
                  value: 'end_with',
                  text: 'Diakhiri Dengan',
                },
              ]},model:{value:(data.operator),callback:function ($$v) {_vm.$set(data, "operator", $$v)},expression:"data.operator"}})],1),_c(VCol,{attrs:{"lg":"4"}},[(data.column == 'guru_id')?[_c('AutoCompleteGuru',{attrs:{"value":data.value},on:{"change":(val) => {
                    data.value = val;
                  }}})]:(data.column == 'rombel_id')?[_c('AutoCompleteRombel',{attrs:{"value":data.value},on:{"change":(val) => {
                    data.value = val;
                  }}})]:(data.column == 'mata_pelajaran_id')?[_c('AutoCompleteMapel',{attrs:{"value":data.value},on:{"change":(val) => {
                    data.value = val;
                  }}})]:(data.column == 'hari')?[_c(VAutocomplete,{attrs:{"label":"Hari","items":[
                  {
                    value: 'senin',
                    text: 'Senin',
                  },
                  {
                    value: 'selasa',
                    text: 'Selasa',
                  },
                  {
                    value: 'rabu',
                    text: 'Rabu',
                  },
                  {
                    value: 'kamis',
                    text: 'Kamis',
                  },
                  {
                    value: 'jumat',
                    text: 'Jumat',
                  },
                  {
                    value: 'sabtu',
                    text: 'Sabtu',
                  },
                ]},model:{value:(data.value),callback:function ($$v) {_vm.$set(data, "value", $$v)},expression:"data.value"}})]:(data.column == 'jam_kbm.ke')?[_c(VTextField,{attrs:{"label":"Jam KBM","placeholder":'Contoh: ' + data.operator == 'antara' ? '1' : '1-12',"type":"text","max":"12","min":"1","prefix":"Ke-"},model:{value:(data.value),callback:function ($$v) {_vm.$set(data, "value", $$v)},expression:"data.value"}})]:[_c(VTextField,{attrs:{"label":"Ketikkan Sesuatu","clearable":""},model:{value:(data.value),callback:function ($$v) {_vm.$set(data, "value", $$v)},expression:"data.value"}})]],2),_c(VCol,{attrs:{"lg":"1"}},[_c(VBtn,{attrs:{"icon":"","color":"red"},on:{"click":() => _vm.removeFilter(i)}},[_c(VIcon,[_vm._v("mdi-delete")])],1)],1)],1)]:[_c(VRow,[(i != 0)?[_c(VCol,{attrs:{"lg":"2"}},[_c(VAutocomplete,{attrs:{"label":"Tipe","items":[
                  {
                    value: 'and',
                    text: 'And',
                  },
                  {
                    value: 'or',
                    text: 'Or',
                  },
                ]},model:{value:(data.type),callback:function ($$v) {_vm.$set(data, "type", $$v)},expression:"data.type"}})],1)]:_vm._e(),_c(VCol,[_c('MultiFilterJadwalMengajar',{attrs:{"filters":data.filters,"type":data.type,"remove":() => _vm.removeFilter(i),"index":_vm.groupIndex + 1},on:{"update:filters":function($event){return _vm.$set(data, "filters", $event)},"update:type":function($event){return _vm.$set(data, "type", $event)}}})],1)],2)]]}),_c('div',{attrs:{"align":"right"}},[_c(VBtn,{attrs:{"small":"","dark":"","color":"darkgray"},on:{"click":_vm.addFilter}},[_c(VIcon,[_vm._v("mdi-plus")]),_vm._v(" Filter ")],1),(_vm.groupIndex < 3)?[_vm._v("   "),_c(VBtn,{attrs:{"small":"","dark":"","color":"darkgray"},on:{"click":_vm.addGroupFilter}},[_c(VIcon,[_vm._v("mdi-plus")]),_vm._v(" Filter Group ")],1)]:_vm._e(),(_vm.groupIndex >= 1)?[_vm._v("   "),_c(VBtn,{attrs:{"small":"","dark":"","color":"red"},on:{"click":_vm.remove}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-delete")])],1)]:_vm._e()],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }